import { useState } from 'react';

import { WrappedControlProps } from 'app/components/Controls/WrappedControlProps';
import { isValidNipNumber } from 'app/validators/validateNipNumber';
import { clearAnonymization } from 'app/shared/helpers/clearAnonymization';

export function useNipNumberControl({
  input,
  input: { value },
  meta: { touched, valid },
  onClick,
  onControlBlur,
  onValueChange,
}: WrappedControlProps) {
  const [focused, setFocused] = useState(false);
  const error = touched && !valid;

  const onFocus = (e: React.FocusEvent<HTMLInputElement>) =>
    handleFocus(e.target.value);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const eventValue = event.target.value
      .replace(/[^\d]/gi, '')
      .trim()
      .slice(0, 10);

    input.onChange(eventValue);

    if (onValueChange) {
      onValueChange(eventValue, false, false);
    }
  };

  const handleFocus = (value: string) => {
    const clearedValue = clearAnonymization(value);
    setFocused(true);

    if (clearedValue !== value) {
      input.onChange(clearedValue);
      if (onValueChange) {
        onValueChange(clearedValue, false, false);
      }
    }
  };

  const handleBlur = () => {
    input.onBlur(value);
    setFocused(false);

    const shouldPatch = isValidNipNumber(value) || value === '';

    if (onControlBlur) {
      onControlBlur(shouldPatch);
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  return {
    focused,
    error,
    handleBlur,
    handleChange,
    onFocus,
    handleClick,
  };
}
